import { DEVICES, PROJECTS, get } from "./Client";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";

export function useGetDevices() {
    let project = useSelector(store => store.session.project)
    const { status, data, error } = useQuery(['devices'], () =>
		get(`${PROJECTS}/${project?.id}/${DEVICES}`), {
			enabled: !!project,
			select: data => data.sort((a, b) => sortDevices(a, b)),
		}
    )
    return { status, devices: data || [], error }
}

/**
 * Criterio di ordinamento centraline (device)
 * @param {*} a device A
 * @param {*} b device B
 */
export function sortDevices(a, b) {
	if (a.label && b.label) {
		return a.label.localeCompare(b.label)
	}
	else if (a.device && b.device) {
		return a.device.localeCompare(b.device)
	}
	else if (a.id && b.id) {
		return b.id < a.id
	}
	else return false
}
